module.exports = __webpack_public_path__ + "static/media/integral_ticket_bg_1.9802b7cc.png";